import { Injectable } from '@angular/core';
import { ReleaseNotesService } from './release-notes.service';
import { DataService } from 'src/app/helpers/data.service';
import { iReleaseNotesResponse } from 'src/app/helpers/Interfaces/release-notes';
import { BehaviorSubject, distinctUntilChanged, map, ReplaySubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReleaseNotesGateService {

  private _activeNote?: iReleaseNotesResponse;
  private _loading = false;
  private _loaded = false;

  private _activeSubject = new BehaviorSubject<iReleaseNotesResponse | undefined>(undefined);
  readonly active$ = this._activeSubject.asObservable();

  readonly hasActive$ = this.active$.pipe(
    map(note => !!note),
    distinctUntilChanged()
  );

  constructor(
    private _releaseNotesServ: ReleaseNotesService,
    private _dataServ: DataService
  ) { }

  loadActive(): void {
    if (this._loaded || this._loading) return;

    this._loading = true;
    const today = new Date().toISOString().split('T')[0];

    this._releaseNotesServ.getNotExpired(today).subscribe({
      next: (note) => {
        this._activeNote = note ?? undefined;
        this._activeSubject.next(this._activeNote);
        this._loading = false;
      },
      error: () => {
        this._activeNote = undefined;
        this._activeSubject.next(undefined);
        this._loading = false;
      }
    });
  }

  check(show: (note: iReleaseNotesResponse) => void): void {
    if (!this._activeNote) return;

    const seen = this._dataServ.releaseNotesSeenValue;
    const shouldShow =
      !seen ||
      seen.id !== this._activeNote.id ||
      seen.expiredAt !== this._activeNote.expiredAt;

    if (shouldShow) show(this._activeNote);
  }

  getActive(): iReleaseNotesResponse | undefined {
    return this._activeNote;
  }

  markAsSeen(note: iReleaseNotesResponse): void {
    this._dataServ.setReleaseNotesSeen({
      id: note.id!,
      expiredAt: note.expiredAt,
      seenAt: new Date().toISOString()
    });
  }
}

@Injectable({ providedIn: 'root' })
export class ReleaseNotesUiService {
  private _open$ = new Subject<void>();
  open$ = this._open$.asObservable();

  open() {
    this._open$.next();
  }
}